module.exports = __webpack_public_path__ + "media/images/flags/1x1/ssd-03b29bfc4412d3b9df80a68b235c8082.svg";